import { render, staticRenderFns } from "./file-container.vue?vue&type=template&id=1f7cfd0c&scoped=true&"
import script from "./file-container.vue?vue&type=script&lang=js&"
export * from "./file-container.vue?vue&type=script&lang=js&"
import style0 from "./file-container.vue?vue&type=style&index=0&id=1f7cfd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7cfd0c",
  null
  
)

export default component.exports